import React from 'react';
import type { ClientShell } from '../../constants/clientShell';
import '../UserAuth/AuthStyles.css';

interface ClientShellSwitcherProps {
  value: ClientShell;
  onChange: (shell: ClientShell) => void;
  /** auth：登录卡片内；compact：顶栏等小空间 */
  variant?: 'auth' | 'compact';
}

export const ClientShellSwitcher: React.FC<ClientShellSwitcherProps> = ({
  value,
  onChange,
  variant = 'auth',
}) => (
  <div
    className={variant === 'auth' ? 'client-shell-switcher client-shell-switcher--auth' : 'client-shell-switcher client-shell-switcher--compact'}
    role="group"
    aria-label="客户端模式"
  >
    <button
      type="button"
      className={`client-shell-switcher__btn${value === 'mobile' ? ' client-shell-switcher__btn--active' : ''}`}
      onClick={() => onChange('mobile')}
    >
      移动端
    </button>
    <button
      type="button"
      className={`client-shell-switcher__btn${value === 'pc' ? ' client-shell-switcher__btn--active' : ''}`}
      onClick={() => onChange('pc')}
    >
      PC 端
    </button>
  </div>
);
